<template>
    <v-container
        id="addperson"
        class="pa-0"
    >
        <v-row
            no-gutters
        >
            <v-col
                cols="12"
            >
                <v-card
                    class="pb-5"
                    style="overflow-y: hidden; overflow-x: hidden"
                >
                    <v-row
                        class="grey lighten-3"
                    >
                        <v-card-title
                            class="headline ml-3"
                            primary-title
                        >
                            {{ cardTitle }}
                        </v-card-title>
                        <v-btn
                            absolute
                            small
                            fab
                            class="mr-3 text-right"
                            style="top: 10px; right: 10px;"
                            @click.prevent="cancelAddPerson"
                        >
                            <v-icon>
                                close
                            </v-icon>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <v-col
                            class="px-10"
                        >

                            <v-row>
                                <v-text-field
                                    v-model="name"
                                    :label="people.length < 1 ? 'Your Name' : 'Name'"
                                    class="mx-5 mt-5 mb-0 pa-0"
                                    @keydown.enter="addPerson"
                                ></v-text-field>
                            </v-row>

                            <v-row
                                class="flex-nowrap"
                            >
                                <v-col
                                    cols="6"
                                    class="ma-0 pa-0"
                                >
                                    <v-text-field
                                    v-model="birthYear"
                                    label="Birth Year"
                                    type="number"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="ma-0 pa-0"
                                >
                                    <v-select
                                    v-model="gender"
                                    :items="['M','F']"
                                    label="Gender"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="!((new Date().getFullYear() - this.birthYear) < 16)"
                                class="flex-nowrap"
                            >
                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                    v-model="heightFt"
                                    label="Ft"
                                    suffix="ft"
                                    type="number"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                ></v-text-field>
                            </v-col>

                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                    v-model="heightIn"
                                    label="In"
                                    suffix="in"
                                    type="number"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                ></v-text-field>
                            </v-col>
                            </v-row>

                            <v-row
                                v-if="!((new Date().getFullYear() - birthYear) < 16)"
                            >
                                <v-col
                                    cols="6"
                                    class="ma-0 pa-0"
                                >
                                    <v-text-field
                                        v-model="weight"
                                        label="Weight"
                                        type="number"
                                        suffix="lbs"
                                        class="mx-5 my-0 pa-0"
                                        @keydown.enter="addPerson"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="ma-0 pa-0"
                                >
                                    <v-text-field
                                        v-model="goalWeight"
                                        label="Goal Weight"
                                        type="number"
                                        suffix="lbs"
                                        class="mx-5 my-0 pa-0"
                                        @keydown.enter="addPerson"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="!((new Date().getFullYear() - birthYear) < 16)"
                            >
                                <v-select
                                    v-model="activityLevel"
                                    :items="['sedentary','light','active','very active']"
                                    label="Activity Level"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                ></v-select>
                            </v-row>

                            <v-row
                                v-else
                            >
                                <v-select
                                    v-model="activityLevel"
                                    :items="['light','active','very active']"
                                    label="Activity Level"
                                    class="mx-5 my-0 pa-0"
                                    @keydown.enter="addPerson"
                                ></v-select>
                            </v-row>

                            <!-- <v-row>
                                <v-text-field
                                    v-model="targetCalories"
                                    label="Target Calories"
                                    type="number"
                                    class="mx-5 my-0 pa-0"
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-row> -->
                            
                            <v-row
                            v-if="((new Date().getFullYear() - birthYear) < 16)"
                            >
                                <v-col
                                    class="text-center mt-2"
                                >
                                    Children under 16 have a simplified form
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row
                        class="my-0 mx-5 pa-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-col
                            class="shrink"
                        >
                            <v-btn
                                color="red"
                                class="mt-0 mr-4 white--text"
                                @click.prevent="cancelAddPerson"
                            >
                                Cancel
                            </v-btn>
                        </v-col>
                        <v-col
                            class="shrink"
                        >
                            <v-btn
                                color="blue"
                                class="mt-0 white--text"
                                @click.prevent="addPerson"
                                :disabled="!readyToSave"
                            >
                                Save
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {

    data: () => ({
        name: null,
        gender: null,
        birthYear: null,
        weight: null,
        heightFt: null,
        heightIn: null,
        activityLevel: null,
        goalWeight: null,
    }),

    methods: {
        cancelAddPerson: function() {
            this.name = null;
            this.gender = null;
            this.birthYear = null;
            this.weight = null;
            this.heightFt = null;
            this.heightIn = null;
            this.activityLevel = null;
            this.goalWeight = null;
            this.newPerson = false;
            this.$store.dispatch('data/resetSuggestedCalories')
        },

        addPerson: function() {
            // console.log('name', this.name);
            // console.log('gender',this.gender);
            // console.log('birthYear',this.birthYear);
            // console.log('weight',this.weight);
            // console.log('heightFt',this.heightFt);
            // console.log('heightIn',this.heightIn);
            // console.log('activityLevel',this.activityLevel);
            // console.log('goalWeight',this.goalWeight);
            // console.log('targetCalories',this.targetCalories);
            // console.log('suggestedCalories',this.suggestedCalories);


            let dispatchLocation = null;

            if (window.location.href.indexOf("signup") >= 0) {
                dispatchLocation = 'data/addPeople';
            } else {
                dispatchLocation = 'data/addIndividual'
            }

            if (this.readyToSave) {
                let age = (new Date().getFullYear() - this.birthYear);

                if (age >= 16) {
                    this.$store.dispatch(dispatchLocation,{
                    name: this.name,
                    gender: this.gender,
                    birth_year: this.birthYear,
                    weight_lb: this.weight,
                    height_ft: this.heightFt,
                    height_in: this.heightIn,
                    activity_level: this.activityLevel,
                    goal_weight: this.goalWeight,
                    daily_calorie_target: this.targetCalories,
                    suggested_calories: this.suggestedCalories
                    })
                } else {
                    this.$store.dispatch(dispatchLocation,{
                    name: this.name,
                    gender: this.gender,
                    birth_year: this.birthYear,
                    weight_lb: null,
                    height_ft: null,
                    height_in: null,
                    activity_level: this.activityLevel,
                    goal_weight: null,
                    daily_calorie_target: this.targetCalories,
                    suggested_calories: this.suggestedCalories
                    })
                }
                this.name = null;
                this.gender = null;
                this.birthYear = null;
                this.weight = null;
                this.heightFt = null;
                this.heightIn = null;
                this.activityLevel = null;
                this.goalWeight = null;
                this.$store.dispatch('data/resetSuggestedCalories')
                this.newPerson = false;
            }
        },

    },

    computed: {
        people() {
            return this.$store.getters['data/people'];
        },

        individuals() {
            return this.$store.getters['data/individual'];
        },

        targetCalories() {
            return this.suggestedCalories;
        },

        suggestedCalories() {
            return this.$store.getters['data/suggestedCalories'];
        },

        newPerson: {
            get() {
                return this.$store.getters['data/newPerson'];
            },
            set(value) {
                this.$store.dispatch('data/updateNewPerson',value);
            }
        },

        cardTitle() {
            let response = null;

            if (window.location.href.indexOf("signup") >= 0) {
                if (this.people.length < 1) {
                    response = 'Add Self'
                } else {
                    response = 'Add Person'
                }
            } else {
                if (this.individuals.length < 1) {
                    response = 'Add Self'
                } else {
                    response = 'Add Person'
                }
            }

            return response;
        },

        readyToSave() {
            let age = (new Date().getFullYear() - this.birthYear);

            if (
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16) &&
                this.targetCalories != null
            ) {
                return true
            } else {
                return false
            }
        },

    },

    watch: {
        gender: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        birthYear: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        weight: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        heightFt: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        heightIn: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        activityLevel: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
        goalWeight: function() {
            let age = (new Date().getFullYear() - this.birthYear);

            if(
                this.name != null &&
                this.gender != null &&
                this.birthYear != null &&
                (this.weight != null || age < 16) &&
                (this.heightFt != null || age < 16) &&
                (this.heightIn != null || age < 16) &&
                this.activityLevel != null &&
                (this.goalWeight != null || age < 16)
            ){
                this.$store.dispatch('data/updateSuggestedCalories',[0,'new',{
                    gender: this.gender,
                    birthYear: this.birthYear,
                    weight: this.weight,
                    heightFt: this.heightFt,
                    heightIn: this.heightIn,
                    activityLevel: this.activityLevel,
                    goalWeight: this.goalWeight,
                }])
            }
        },
    },

}

</script>